import React from 'react'
import './contactus.css'

const ContactUs = () => {
    const SubmitForm = (e) => {
        e.preventDefault(); // Prevent default submission behavior
        alert("Form submitted successfully");

        // Submit the form data to Formspree
        e.target.closest('form').submit();
    };
    return (
        <>
            <div class="container">
                <form action="https://formspree.io/f/xrbgdbpe" target='_blank' method='POST'>
                    <div class="form-row">
                        <div class="input-data">
                            <input type="text" name='first name' required />
                            <label for="">First Name</label>
                        </div>
                        <div class="input-data">
                            <input type="text" name='last name' required />
                            <label for="">Last Name</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="input-data">
                            <input type="text" name='email' required />
                            <label for="">Email Address</label>
                        </div>
                        <div class="input-data">
                            <input type="text" name='website' required />
                            <label for="">Website Name</label>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="input-data textarea">
                            <textarea rows="8" cols="80" name='message' required></textarea>
                            <br />
                            <label for="">Write your message</label>
                            <br />
                            <div class="form-row submit-btn">
                                <div class="input-data">
                                    {/* <input type="submit" value="submit" /> */}
                                    <button className='SubmitBtn'>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default ContactUs